import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { AuthService } from '@service/auth.service';

import { Subscription, catchError, lastValueFrom, map, of } from 'rxjs';

@Component({
    selector: 'app-signin-role',
    templateUrl: './signin-role.component.html',
    styleUrls: ['./signin-role.component.scss'],
    standalone: false
})
export class SigninRoleComponent implements OnDestroy, OnInit {
    @Output() showPasswordOverlay = new EventEmitter<string>();

    visible: boolean = false;
    showLearnMore: boolean = false;
    signInSubscription: Subscription;
    userListUpdatedSubscription: Subscription;

    roleTypeArray: { role: string; id: string }[] = [];

    loading: boolean = true;

    constructor(
        private authService: AuthService,
        private iconRegistry: MatIconRegistry,
    ) {
        this.signInSubscription = authService.showSignIn$.subscribe((result) => {
            this.visible = result;
        });

        this.userListUpdatedSubscription = authService.userListUpdated$.subscribe(async()=> {
            this.loading = true;
            this.roleTypeArray = await authService.getUserRoles();
            this.loading = false;
        })

    }
    async ngOnInit(): Promise<void> {
        this.roleTypeArray = await this.authService.getUserRoles();
        this.loading = false;
    }

    ngOnDestroy(): void {
        this.signInSubscription?.unsubscribe();
        this.userListUpdatedSubscription?.unsubscribe();
    }

    public setVisible(visible: boolean) {
        this.visible = visible;
    }

    closeOverlay() {
        this.visible = false;
        this.authService.saveCurrentUser()
    }

    public onSelectedRole(event: string) {
        this.showPasswordOverlay.emit(event);
    }

    closeLearnMore() {
        this.showLearnMore = false;
        this.closeOverlay();
    }

    onShowLearnMore() {
        this.showLearnMore = !this.showLearnMore;
    }

    isIconLoaded(icon: string): boolean {
        let iconExists = false;

        this.iconRegistry
            .getNamedSvgIcon(icon)
            .pipe(
                map(() => {
                    iconExists = true;
                }),
                catchError(() => {
                    iconExists = false;
                    return of(null);
                }),
            )
            .subscribe();

        return iconExists;
    }
}
